import { render, staticRenderFns } from "./OperaDictDataWindow.vue?vue&type=template&id=4b283616&scoped=true"
import script from "./OperaDictDataWindow.vue?vue&type=script&lang=js"
export * from "./OperaDictDataWindow.vue?vue&type=script&lang=js"
import style0 from "./OperaDictDataWindow.vue?vue&type=style&index=0&id=4b283616&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b283616",
  null
  
)

export default component.exports